<template>
<v-dialog v-model="dialog" max-width="500">
    <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" icon small v-on="on">
            <v-icon medium color="blue">mdi-lock</v-icon>
        </v-btn>
    </template>
    <v-card>
        <v-card-title>{{ this.user.nomeCompleto }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 300px;">
            <v-select :items="vouchers" v-model="user.voucher" item-text="nome" item-value="_id" label="Vouchers"></v-select>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
            <v-spacer />
            <v-btn color="red darken-1" text @click="dialog = false">
                Cancelar
            </v-btn>
            <v-btn :disabled="user.voucher == undefined || user.voucher == ''" color="blue darken-1" text @click="cadastrarUsuario" :loading="loadCadastro">
                Salvar
            </v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>
import voucherService from '../../../services/voucher.service'
import usuarioService from '../../../services/usuario.service'

export default {
  name: 'vincularVoucher',
  props: {
    usuario: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      dialog: false,
      vouchers: [],
      voucher: {},
      user: {
        nomeCompleto: '',
        voucher: ''
      },
      alert: false,
      loadCadastro: false,
      msgSucesso: '',
      msgErro: ''
    }
  },
  methods: {
    listarVouchers () {
      voucherService.listarVouchers().then((response) => {
        if (response.status == 200) {
          this.vouchers = response.data
        } else {
          this.msgErro = 'Erro ao listar vouchers'
          this.alert = true
        }
      })
    },
    cadastrarUsuario () {
      this.loadCadastro = true
      usuarioService.cadastrarUsuario({
        usuario: { _id: this.user._id }, voucher: { _id: this.user.voucher }
      }).then((response) => {
        if (response.status == 200) {
          this.msgSucesso = 'Usuário cadastrado com sucesso'
          this.alert = true
          this.dialog = false
        } else {
          this.msgErro = 'Erro ao cadastrar usuário'
          this.alert = true
        }
      }).finally(() => {
        this.loadCadastro = false
      })
    }
  },
  mounted () {
    this.listarVouchers()
    this.user = this.usuario
  }
}
</script>
